import cls from 'classnames';
import { FC, RefObject } from 'react';

import ChannelSwitcherDesktop from '@/components/channel-switcher/desktop';

interface ChannelSwitcherDesktopOverlayProps {
  isChannelSwitcherOpen: boolean;
  onChannelSwitcherToggle: () => void;
  channelSwitchRef: RefObject<HTMLElement> | null;
}

const ChannelSwitcherDesktopOverlay: FC<ChannelSwitcherDesktopOverlayProps> = ({
  isChannelSwitcherOpen,
  onChannelSwitcherToggle,
  channelSwitchRef,
}) => (
  <div
    className={cls(
      'fixed inset-x-0 top-0 z-[2147483640] w-screen min-h-screen overflow-hidden pt-24 transform transition-transform duration-500 max-md:hidden',
      isChannelSwitcherOpen
        ? 'translate-y-0 pointer-events-auto'
        : '-translate-y-full pointer-events-none teair:translate-y-full tesn:translate-y-full',
    )}
    aria-hidden={!isChannelSwitcherOpen}
  >
    <ChannelSwitcherDesktop
      ref={channelSwitchRef}
      isOpen={isChannelSwitcherOpen}
      onClose={onChannelSwitcherToggle}
    />
  </div>
);

export default ChannelSwitcherDesktopOverlay;
